import _defineProperty from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import mutate from "dom-mutator";
import { chooseVariation, decrypt, getBucketRanges, getQueryStringOverride, getUrlRegExp, hash, inNamespace, inRange, isIncluded, isURLTargeted, loadSDKVersion, mergeQueryStrings, toString } from "./util";
import { evalCondition } from "./mongrule";
import { refreshFeatures, subscribe, unsubscribe } from "./feature-repository";
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var SDK_VERSION = loadSDKVersion();
export var GrowthBook = /*#__PURE__*/function () {
  // context is technically private, but some tools depend on it so we can't mangle the name
  // _ctx below is a clone of this property that we use internally

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  // eslint-disable-next-line

  function GrowthBook(context) {
    _classCallCheck(this, GrowthBook);
    context = context || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._ctx = this.context = context;
    this._renderer = null;
    this._trackedExperiments = new Set();
    this._trackedFeatures = {};
    this.debug = false;
    this._subscriptions = new Set();
    this._rtQueue = [];
    this._rtTimer = 0;
    this.ready = false;
    this._assigned = new Map();
    this._forcedFeatureValues = new Map();
    this._attributeOverrides = {};
    this._activeAutoExperiments = new Map();
    this._triggeredExpKeys = new Set();
    this._loadFeaturesCalled = false;
    this._redirectedUrl = "";
    this._deferredTrackingCalls = [];
    if (context.renderer) {
      this._renderer = context.renderer;
    }
    if (context.remoteEval) {
      if (context.decryptionKey) {
        throw new Error("Encryption is not available for remoteEval");
      }
      if (!context.clientKey) {
        throw new Error("Missing clientKey");
      }
      var isGbHost = false;
      try {
        isGbHost = !!new URL(context.apiHost || "").hostname.match(/growthbook\.io$/i);
      } catch (e) {
        // ignore invalid URLs
      }
      if (isGbHost) {
        throw new Error("Cannot use remoteEval on GrowthBook Cloud");
      }
    } else {
      if (context.cacheKeyAttributes) {
        throw new Error("cacheKeyAttributes are only used for remoteEval");
      }
    }
    if (context.features) {
      this.ready = true;
    }
    if (isBrowser && context.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (context.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    } else if (context.antiFlicker) {
      this._setAntiFlicker();
    }
    if (context.clientKey && !context.remoteEval) {
      this._refresh({}, true, false);
    }
  }
  _createClass(GrowthBook, [{
    key: "loadFeatures",
    value: function () {
      var _loadFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (options && options.autoRefresh) {
                // interpret deprecated autoRefresh option as subscribeToChanges
                this._ctx.subscribeToChanges = true;
              }
              this._loadFeaturesCalled = true;
              _context.next = 4;
              return this._refresh(options, true, true);
            case 4:
              if (this._canSubscribe()) {
                subscribe(this);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadFeatures(_x) {
        return _loadFeatures.apply(this, arguments);
      }
      return loadFeatures;
    }()
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._refresh(options, false, true);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function refreshFeatures(_x2) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      var defaultHost = this._ctx.apiHost || "https://cdn.growthbook.io";
      return {
        apiHost: defaultHost.replace(/\/*$/, ""),
        streamingHost: (this._ctx.streamingHost || defaultHost).replace(/\/*$/, ""),
        apiRequestHeaders: this._ctx.apiHostRequestHeaders,
        streamingHostRequestHeaders: this._ctx.streamingHostRequestHeaders
      };
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._ctx.clientKey || "";
    }
  }, {
    key: "isRemoteEval",
    value: function isRemoteEval() {
      return this._ctx.remoteEval || false;
    }
  }, {
    key: "getCacheKeyAttributes",
    value: function getCacheKeyAttributes() {
      return this._ctx.cacheKeyAttributes;
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options, allowStale, updateInstance) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = options || {};
              if (this._ctx.clientKey) {
                _context3.next = 3;
                break;
              }
              throw new Error("Missing clientKey");
            case 3:
              _context3.next = 5;
              return refreshFeatures(this, options.timeout, options.skipCache || this._ctx.enableDevMode, allowStale, updateInstance, this._ctx.backgroundSync !== false);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _refresh(_x3, _x4, _x5) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "_render",
    value: function _render() {
      if (this._renderer) {
        try {
          this._renderer();
        } catch (e) {
          console.error("Failed to render", e);
        }
      }
    }
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this._ctx.features = features;
      this.ready = true;
      this._render();
    }
  }, {
    key: "setEncryptedFeatures",
    value: function () {
      var _setEncryptedFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(encryptedString, decryptionKey, subtle) {
        var featuresJSON;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
            case 2:
              featuresJSON = _context4.sent;
              this.setFeatures(JSON.parse(featuresJSON));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setEncryptedFeatures(_x6, _x7, _x8) {
        return _setEncryptedFeatures.apply(this, arguments);
      }
      return setEncryptedFeatures;
    }()
  }, {
    key: "setExperiments",
    value: function setExperiments(experiments) {
      this._ctx.experiments = experiments;
      this.ready = true;
      this._updateAllAutoExperiments();
    }
  }, {
    key: "setEncryptedExperiments",
    value: function () {
      var _setEncryptedExperiments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(encryptedString, decryptionKey, subtle) {
        var experimentsJSON;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
            case 2:
              experimentsJSON = _context5.sent;
              this.setExperiments(JSON.parse(experimentsJSON));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setEncryptedExperiments(_x9, _x10, _x11) {
        return _setEncryptedExperiments.apply(this, arguments);
      }
      return setEncryptedExperiments;
    }()
  }, {
    key: "decryptPayload",
    value: function () {
      var _decryptPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data, decryptionKey, subtle) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!data.encryptedFeatures) {
                _context6.next = 7;
                break;
              }
              _context6.t0 = JSON;
              _context6.next = 4;
              return decrypt(data.encryptedFeatures, decryptionKey || this._ctx.decryptionKey, subtle);
            case 4:
              _context6.t1 = _context6.sent;
              data.features = _context6.t0.parse.call(_context6.t0, _context6.t1);
              delete data.encryptedFeatures;
            case 7:
              if (!data.encryptedExperiments) {
                _context6.next = 14;
                break;
              }
              _context6.t2 = JSON;
              _context6.next = 11;
              return decrypt(data.encryptedExperiments, decryptionKey || this._ctx.decryptionKey, subtle);
            case 11:
              _context6.t3 = _context6.sent;
              data.experiments = _context6.t2.parse.call(_context6.t2, _context6.t3);
              delete data.encryptedExperiments;
            case 14:
              return _context6.abrupt("return", data);
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function decryptPayload(_x12, _x13, _x14) {
        return _decryptPayload.apply(this, arguments);
      }
      return decryptPayload;
    }()
  }, {
    key: "setAttributes",
    value: function () {
      var _setAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(attributes) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this._ctx.attributes = attributes;
              if (!this._ctx.stickyBucketService) {
                _context7.next = 4;
                break;
              }
              _context7.next = 4;
              return this.refreshStickyBuckets();
            case 4:
              if (!this._ctx.remoteEval) {
                _context7.next = 8;
                break;
              }
              _context7.next = 7;
              return this._refreshForRemoteEval();
            case 7:
              return _context7.abrupt("return");
            case 8:
              this._render();
              this._updateAllAutoExperiments();
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setAttributes(_x15) {
        return _setAttributes.apply(this, arguments);
      }
      return setAttributes;
    }()
  }, {
    key: "updateAttributes",
    value: function () {
      var _updateAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(attributes) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.setAttributes(_objectSpread({}, this._ctx.attributes, attributes)));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateAttributes(_x16) {
        return _updateAttributes.apply(this, arguments);
      }
      return updateAttributes;
    }()
  }, {
    key: "setAttributeOverrides",
    value: function () {
      var _setAttributeOverrides = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(overrides) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this._attributeOverrides = overrides;
              if (!this._ctx.stickyBucketService) {
                _context9.next = 4;
                break;
              }
              _context9.next = 4;
              return this.refreshStickyBuckets();
            case 4:
              if (!this._ctx.remoteEval) {
                _context9.next = 8;
                break;
              }
              _context9.next = 7;
              return this._refreshForRemoteEval();
            case 7:
              return _context9.abrupt("return");
            case 8:
              this._render();
              this._updateAllAutoExperiments();
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setAttributeOverrides(_x17) {
        return _setAttributeOverrides.apply(this, arguments);
      }
      return setAttributeOverrides;
    }()
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(vars) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this._ctx.forcedVariations = vars || {};
              if (!this._ctx.remoteEval) {
                _context10.next = 5;
                break;
              }
              _context10.next = 4;
              return this._refreshForRemoteEval();
            case 4:
              return _context10.abrupt("return");
            case 5:
              this._render();
              this._updateAllAutoExperiments();
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function setForcedVariations(_x18) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._forcedFeatureValues = map;
      this._render();
    }
  }, {
    key: "setURL",
    value: function () {
      var _setURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(url) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this._ctx.url = url;
              this._redirectedUrl = "";
              if (!this._ctx.remoteEval) {
                _context11.next = 7;
                break;
              }
              _context11.next = 5;
              return this._refreshForRemoteEval();
            case 5:
              this._updateAllAutoExperiments(true);
              return _context11.abrupt("return");
            case 7:
              this._updateAllAutoExperiments(true);
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function setURL(_x19) {
        return _setURL.apply(this, arguments);
      }
      return setURL;
    }()
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread({}, this._ctx.attributes, this._attributeOverrides);
    }
  }, {
    key: "getForcedVariations",
    value: function getForcedVariations() {
      return this._ctx.forcedVariations || {};
    }
  }, {
    key: "getForcedFeatures",
    value: function getForcedFeatures() {
      // eslint-disable-next-line
      return this._forcedFeatureValues || new Map();
    }
  }, {
    key: "getStickyBucketAssignmentDocs",
    value: function getStickyBucketAssignmentDocs() {
      return this._ctx.stickyBucketAssignmentDocs || {};
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return this._ctx.url || "";
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._ctx.features || {};
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      return this._ctx.experiments || [];
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this._subscriptions.add(cb);
      return function () {
        _this._subscriptions.delete(cb);
      };
    }
  }, {
    key: "_canSubscribe",
    value: function _canSubscribe() {
      return this._ctx.backgroundSync !== false && this._ctx.subscribeToChanges;
    }
  }, {
    key: "_refreshForRemoteEval",
    value: function () {
      var _refreshForRemoteEval2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (this._ctx.remoteEval) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return");
            case 2:
              if (this._loadFeaturesCalled) {
                _context12.next = 4;
                break;
              }
              return _context12.abrupt("return");
            case 4:
              _context12.next = 6;
              return this._refresh({}, false, true).catch(function () {
                // Ignore errors
              });
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function _refreshForRemoteEval() {
        return _refreshForRemoteEval2.apply(this, arguments);
      }
      return _refreshForRemoteEval;
    }()
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this._assigned);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Release references to save memory
      this._subscriptions.clear();
      this._assigned.clear();
      this._trackedExperiments.clear();
      this._trackedFeatures = {};
      this._rtQueue = [];
      if (this._rtTimer) {
        clearTimeout(this._rtTimer);
      }
      unsubscribe(this);
      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }

      // Undo any active auto experiments
      this._activeAutoExperiments.forEach(function (exp) {
        exp.undo();
      });
      this._activeAutoExperiments.clear();
      this._triggeredExpKeys.clear();
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this._ctx.forcedVariations = this._ctx.forcedVariations || {};
      this._ctx.forcedVariations[key] = variation;
      if (this._ctx.remoteEval) {
        this._refreshForRemoteEval();
        return;
      }
      this._updateAllAutoExperiments();
      this._render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var result = this._run(experiment, null);
      this._fireSubscriptions(experiment, result);
      return result;
    }
  }, {
    key: "triggerExperiment",
    value: function triggerExperiment(key) {
      var _this2 = this;
      this._triggeredExpKeys.add(key);
      if (!this._ctx.experiments) return null;
      var experiments = this._ctx.experiments.filter(function (exp) {
        return exp.key === key;
      });
      return experiments.map(function (exp) {
        if (!exp.manual) return null;
        return _this2._runAutoExperiment(exp);
      }).filter(function (res) {
        return res !== null;
      });
    }
  }, {
    key: "_runAutoExperiment",
    value: function _runAutoExperiment(experiment, forceRerun) {
      var existing = this._activeAutoExperiments.get(experiment);

      // If this is a manual experiment and it's not already running, skip
      if (experiment.manual && !this._triggeredExpKeys.has(experiment.key) && !existing) return null;

      // Run the experiment
      var result = this.run(experiment);

      // A hash to quickly tell if the assigned value changed
      var valueHash = JSON.stringify(result.value);

      // If the changes are already active, no need to re-apply them
      if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
        return result;
      }

      // Undo any existing changes
      if (existing) this._undoActiveAutoExperiment(experiment);

      // Apply new changes
      if (result.inExperiment) {
        if (result.value.urlRedirect && experiment.urlPatterns) {
          var url = experiment.persistQueryString ? mergeQueryStrings(this._getContextUrl(), result.value.urlRedirect) : result.value.urlRedirect;
          if (isURLTargeted(url, experiment.urlPatterns)) {
            this.log("Skipping redirect because original URL matches redirect URL", {
              id: experiment.key
            });
            return result;
          }
          this._redirectedUrl = url;
          var navigate = this._getNavigateFunction();
          if (navigate) {
            if (isBrowser) {
              var _this$_ctx$navigateDe;
              this._setAntiFlicker();
              window.setTimeout(function () {
                try {
                  navigate(url);
                } catch (e) {
                  console.error(e);
                }
              }, (_this$_ctx$navigateDe = this._ctx.navigateDelay) !== null && _this$_ctx$navigateDe !== void 0 ? _this$_ctx$navigateDe : 100);
            } else {
              try {
                navigate(url);
              } catch (e) {
                console.error(e);
              }
            }
          }
        } else {
          var undo = this._applyDOMChanges(result.value);
          if (undo) {
            this._activeAutoExperiments.set(experiment, {
              undo: undo,
              valueHash: valueHash
            });
          }
        }
      }
      return result;
    }
  }, {
    key: "_undoActiveAutoExperiment",
    value: function _undoActiveAutoExperiment(exp) {
      var data = this._activeAutoExperiments.get(exp);
      if (data) {
        data.undo();
        this._activeAutoExperiments.delete(exp);
      }
    }
  }, {
    key: "_isRedirectExperiment",
    value: function _isRedirectExperiment(exp) {
      return exp.variations.some(function (v) {
        return Object.keys(v).includes("urlRedirect");
      });
    }
  }, {
    key: "_updateAllAutoExperiments",
    value: function _updateAllAutoExperiments(forceRerun) {
      var _this3 = this;
      var experiments = this._ctx.experiments || [];

      // Stop any experiments that are no longer defined
      var keys = new Set(experiments);
      this._activeAutoExperiments.forEach(function (v, k) {
        if (!keys.has(k)) {
          v.undo();
          _this3._activeAutoExperiments.delete(k);
        }
      });

      // Re-run all new/updated experiments
      var _iterator = _createForOfIteratorHelper(experiments),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var exp = _step.value;
          var result = this._runAutoExperiment(exp, forceRerun);

          // Once you're in a redirect experiment, break out of the loop and don't run any further experiments
          if (result !== null && result !== void 0 && result.inExperiment && this._isRedirectExperiment(exp)) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_fireSubscriptions",
    value: function _fireSubscriptions(experiment, result) {
      var key = experiment.key;

      // If assigned variation has changed, fire subscriptions
      var prev = this._assigned.get(key);
      // TODO: what if the experiment definition has changed?
      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this._assigned.set(key, {
          experiment: experiment,
          result: result
        });
        this._subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "_trackFeatureUsage",
    value: function _trackFeatureUsage(key, res) {
      var _this4 = this;
      // Don't track feature usage that was forced via an override
      if (res.source === "override") return;

      // Only track a feature once, unless the assigned value changed
      var stringifiedValue = JSON.stringify(res.value);
      if (this._trackedFeatures[key] === stringifiedValue) return;
      this._trackedFeatures[key] = stringifiedValue;

      // Fire user-supplied callback
      if (this._ctx.onFeatureUsage) {
        try {
          this._ctx.onFeatureUsage(key, res);
        } catch (e) {
          // Ignore feature usage callback errors
        }
      }

      // In browser environments, queue up feature usage to be tracked in batches
      if (!isBrowser || !window.fetch) return;
      this._rtQueue.push({
        key: key,
        on: res.on
      });
      if (!this._rtTimer) {
        this._rtTimer = window.setTimeout(function () {
          // Reset the queue
          _this4._rtTimer = 0;
          var q = _toConsumableArray(_this4._rtQueue);
          _this4._rtQueue = [];

          // Skip logging if a real-time usage key is not configured
          if (!_this4._ctx.realtimeKey) return;
          window.fetch("https://rt.growthbook.io/?key=".concat(_this4._ctx.realtimeKey, "&events=").concat(encodeURIComponent(JSON.stringify(q))), {
            cache: "no-cache",
            mode: "no-cors"
          }).catch(function () {
            // TODO: retry in case of network errors?
          });
        }, this._ctx.realtimeInterval || 2000);
      }
    }
  }, {
    key: "_getFeatureResult",
    value: function _getFeatureResult(key, value, source, ruleId, experiment, result) {
      var ret = {
        value: value,
        on: !!value,
        off: !value,
        source: source,
        ruleId: ruleId || ""
      };
      if (experiment) ret.experiment = experiment;
      if (result) ret.experimentResult = result;

      // Track the usage of this feature in real-time
      this._trackFeatureUsage(key, ret);
      return ret;
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var value = this.evalFeature(key).value;
      return value === null ? defaultValue : value;
    }
    /**
     * @deprecated Use {@link evalFeature}
     * @param id
     */
    // eslint-disable-next-line
  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return this._evalFeature(id);
    }
  }, {
    key: "_evalFeature",
    value: function _evalFeature(id, evalCtx) {
      var _this5 = this;
      evalCtx = evalCtx || {
        evaluatedFeatures: new Set()
      };
      if (evalCtx.evaluatedFeatures.has(id)) {
        process.env.NODE_ENV !== "production" && this.log("evalFeature: circular dependency detected: ".concat(evalCtx.id, " -> ").concat(id), {
          from: evalCtx.id,
          to: id
        });
        return this._getFeatureResult(id, null, "cyclicPrerequisite");
      }
      evalCtx.evaluatedFeatures.add(id);
      evalCtx.id = id;

      // Global override
      if (this._forcedFeatureValues.has(id)) {
        process.env.NODE_ENV !== "production" && this.log("Global override", {
          id: id,
          value: this._forcedFeatureValues.get(id)
        });
        return this._getFeatureResult(id, this._forcedFeatureValues.get(id), "override");
      }

      // Unknown feature id
      if (!this._ctx.features || !this._ctx.features[id]) {
        process.env.NODE_ENV !== "production" && this.log("Unknown feature", {
          id: id
        });
        return this._getFeatureResult(id, null, "unknownFeature");
      }

      // Get the feature
      var feature = this._ctx.features[id];

      // Loop through the rules
      if (feature.rules) {
        var _iterator2 = _createForOfIteratorHelper(feature.rules),
          _step2;
        try {
          rules: for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var rule = _step2.value;
            // If there are prerequisite flag(s), evaluate them
            if (rule.parentConditions) {
              var _iterator3 = _createForOfIteratorHelper(rule.parentConditions),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var parentCondition = _step3.value;
                  var parentResult = this._evalFeature(parentCondition.id, evalCtx);
                  // break out for cyclic prerequisites
                  if (parentResult.source === "cyclicPrerequisite") {
                    return this._getFeatureResult(id, null, "cyclicPrerequisite");
                  }
                  var evalObj = {
                    value: parentResult.value
                  };
                  var evaled = evalCondition(evalObj, parentCondition.condition || {});
                  if (!evaled) {
                    // blocking prerequisite eval failed: feature evaluation fails
                    if (parentCondition.gate) {
                      process.env.NODE_ENV !== "production" && this.log("Feature blocked by prerequisite", {
                        id: id,
                        rule: rule
                      });
                      return this._getFeatureResult(id, null, "prerequisite");
                    }
                    // non-blocking prerequisite eval failed: break out of parentConditions loop, jump to the next rule
                    process.env.NODE_ENV !== "production" && this.log("Skip rule because prerequisite evaluation fails", {
                      id: id,
                      rule: rule
                    });
                    continue rules;
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }

            // If there are filters for who is included (e.g. namespaces)
            if (rule.filters && this._isFilteredOut(rule.filters)) {
              process.env.NODE_ENV !== "production" && this.log("Skip rule because of filters", {
                id: id,
                rule: rule
              });
              continue;
            }

            // Feature value is being forced
            if ("force" in rule) {
              // If it's a conditional rule, skip if the condition doesn't pass
              if (rule.condition && !this._conditionPasses(rule.condition)) {
                process.env.NODE_ENV !== "production" && this.log("Skip rule because of condition ff", {
                  id: id,
                  rule: rule
                });
                continue;
              }

              // If this is a percentage rollout, skip if not included
              if (!this._isIncludedInRollout(rule.seed || id, rule.hashAttribute, this._ctx.stickyBucketService && !rule.disableStickyBucketing ? rule.fallbackAttribute : undefined, rule.range, rule.coverage, rule.hashVersion)) {
                process.env.NODE_ENV !== "production" && this.log("Skip rule because user not included in rollout", {
                  id: id,
                  rule: rule
                });
                continue;
              }
              process.env.NODE_ENV !== "production" && this.log("Force value from rule", {
                id: id,
                rule: rule
              });

              // If this was a remotely evaluated experiment, fire the tracking callbacks
              if (rule.tracks) {
                rule.tracks.forEach(function (t) {
                  _this5._track(t.experiment, t.result);
                });
              }
              return this._getFeatureResult(id, rule.force, "force", rule.id);
            }
            if (!rule.variations) {
              process.env.NODE_ENV !== "production" && this.log("Skip invalid rule", {
                id: id,
                rule: rule
              });
              continue;
            }

            // For experiment rules, run an experiment
            var exp = {
              variations: rule.variations,
              key: rule.key || id
            };
            if ("coverage" in rule) exp.coverage = rule.coverage;
            if (rule.weights) exp.weights = rule.weights;
            if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
            if (rule.fallbackAttribute) exp.fallbackAttribute = rule.fallbackAttribute;
            if (rule.disableStickyBucketing) exp.disableStickyBucketing = rule.disableStickyBucketing;
            if (rule.bucketVersion !== undefined) exp.bucketVersion = rule.bucketVersion;
            if (rule.minBucketVersion !== undefined) exp.minBucketVersion = rule.minBucketVersion;
            if (rule.namespace) exp.namespace = rule.namespace;
            if (rule.meta) exp.meta = rule.meta;
            if (rule.ranges) exp.ranges = rule.ranges;
            if (rule.name) exp.name = rule.name;
            if (rule.phase) exp.phase = rule.phase;
            if (rule.seed) exp.seed = rule.seed;
            if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
            if (rule.filters) exp.filters = rule.filters;
            if (rule.condition) exp.condition = rule.condition;

            // Only return a value if the user is part of the experiment
            var res = this._run(exp, id);
            this._fireSubscriptions(exp, res);
            if (res.inExperiment && !res.passthrough) {
              return this._getFeatureResult(id, res.value, "experiment", rule.id, exp, res);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      process.env.NODE_ENV !== "production" && this.log("Use default value", {
        id: id,
        value: feature.defaultValue
      });

      // Fall back to using the default value
      return this._getFeatureResult(id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
    }
  }, {
    key: "_isIncludedInRollout",
    value: function _isIncludedInRollout(seed, hashAttribute, fallbackAttribute, range, coverage, hashVersion) {
      if (!range && coverage === undefined) return true;
      var _this$_getHashAttribu = this._getHashAttribute(hashAttribute, fallbackAttribute),
        hashValue = _this$_getHashAttribu.hashValue;
      if (!hashValue) {
        return false;
      }
      var n = hash(seed, hashValue, hashVersion || 1);
      if (n === null) return false;
      return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
    }
  }, {
    key: "_conditionPasses",
    value: function _conditionPasses(condition) {
      return evalCondition(this.getAttributes(), condition);
    }
  }, {
    key: "_isFilteredOut",
    value: function _isFilteredOut(filters) {
      var _this6 = this;
      return filters.some(function (filter) {
        var _this6$_getHashAttrib = _this6._getHashAttribute(filter.attribute),
          hashValue = _this6$_getHashAttrib.hashValue;
        if (!hashValue) return true;
        var n = hash(filter.seed, hashValue, filter.hashVersion || 2);
        if (n === null) return true;
        return !filter.ranges.some(function (r) {
          return inRange(n, r);
        });
      });
    }
  }, {
    key: "_run",
    value: function _run(experiment, featureId) {
      var key = experiment.key;
      var numVariations = experiment.variations.length;

      // 1. If experiment has less than 2 variations, return immediately
      if (numVariations < 2) {
        process.env.NODE_ENV !== "production" && this.log("Invalid experiment", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 2. If the context is disabled, return immediately
      if (this._ctx.enabled === false) {
        process.env.NODE_ENV !== "production" && this.log("Context disabled", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 2.5. Merge in experiment overrides from the context
      experiment = this._mergeOverrides(experiment);

      // 2.6 New, more powerful URL targeting
      if (experiment.urlPatterns && !isURLTargeted(this._getContextUrl(), experiment.urlPatterns)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of url targeting", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 3. If a variation is forced from a querystring, return the forced variation
      var qsOverride = getQueryStringOverride(key, this._getContextUrl(), numVariations);
      if (qsOverride !== null) {
        process.env.NODE_ENV !== "production" && this.log("Force via querystring", {
          id: key,
          variation: qsOverride
        });
        return this._getResult(experiment, qsOverride, false, featureId);
      }

      // 4. If a variation is forced in the context, return the forced variation
      if (this._ctx.forcedVariations && key in this._ctx.forcedVariations) {
        var variation = this._ctx.forcedVariations[key];
        process.env.NODE_ENV !== "production" && this.log("Force via dev tools", {
          id: key,
          variation: variation
        });
        return this._getResult(experiment, variation, false, featureId);
      }

      // 5. Exclude if a draft experiment or not active
      if (experiment.status === "draft" || experiment.active === false) {
        process.env.NODE_ENV !== "production" && this.log("Skip because inactive", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 6. Get the hash attribute and return if empty
      var _this$_getHashAttribu2 = this._getHashAttribute(experiment.hashAttribute, this._ctx.stickyBucketService && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
        hashAttribute = _this$_getHashAttribu2.hashAttribute,
        hashValue = _this$_getHashAttribu2.hashValue;
      if (!hashValue) {
        process.env.NODE_ENV !== "production" && this.log("Skip because missing hashAttribute", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }
      var assigned = -1;
      var foundStickyBucket = false;
      var stickyBucketVersionIsBlocked = false;
      if (this._ctx.stickyBucketService && !experiment.disableStickyBucketing) {
        var _this$_getStickyBucke = this._getStickyBucketVariation(experiment.key, experiment.bucketVersion, experiment.minBucketVersion, experiment.meta),
          _variation = _this$_getStickyBucke.variation,
          versionIsBlocked = _this$_getStickyBucke.versionIsBlocked;
        foundStickyBucket = _variation >= 0;
        assigned = _variation;
        stickyBucketVersionIsBlocked = !!versionIsBlocked;
      }

      // Some checks are not needed if we already have a sticky bucket
      if (!foundStickyBucket) {
        // 7. Exclude if user is filtered out (used to be called "namespace")
        if (experiment.filters) {
          if (this._isFilteredOut(experiment.filters)) {
            process.env.NODE_ENV !== "production" && this.log("Skip because of filters", {
              id: key
            });
            return this._getResult(experiment, -1, false, featureId);
          }
        } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
          process.env.NODE_ENV !== "production" && this.log("Skip because of namespace", {
            id: key
          });
          return this._getResult(experiment, -1, false, featureId);
        }

        // 7.5. Exclude if experiment.include returns false or throws
        if (experiment.include && !isIncluded(experiment.include)) {
          process.env.NODE_ENV !== "production" && this.log("Skip because of include function", {
            id: key
          });
          return this._getResult(experiment, -1, false, featureId);
        }

        // 8. Exclude if condition is false
        if (experiment.condition && !this._conditionPasses(experiment.condition)) {
          process.env.NODE_ENV !== "production" && this.log("Skip because of condition exp", {
            id: key
          });
          return this._getResult(experiment, -1, false, featureId);
        }

        // 8.05. Exclude if prerequisites are not met
        if (experiment.parentConditions) {
          var _iterator4 = _createForOfIteratorHelper(experiment.parentConditions),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var parentCondition = _step4.value;
              var parentResult = this._evalFeature(parentCondition.id);
              // break out for cyclic prerequisites
              if (parentResult.source === "cyclicPrerequisite") {
                return this._getResult(experiment, -1, false, featureId);
              }
              var evalObj = {
                value: parentResult.value
              };
              if (!evalCondition(evalObj, parentCondition.condition || {})) {
                process.env.NODE_ENV !== "production" && this.log("Skip because prerequisite evaluation fails", {
                  id: key
                });
                return this._getResult(experiment, -1, false, featureId);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }

        // 8.1. Exclude if user is not in a required group
        if (experiment.groups && !this._hasGroupOverlap(experiment.groups)) {
          process.env.NODE_ENV !== "production" && this.log("Skip because of groups", {
            id: key
          });
          return this._getResult(experiment, -1, false, featureId);
        }
      }

      // 8.2. Old style URL targeting
      if (experiment.url && !this._urlIsValid(experiment.url)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of url", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 9. Get the variation from the sticky bucket or get bucket ranges and choose variation
      var n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
      if (n === null) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of invalid hash version", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }
      if (!foundStickyBucket) {
        var ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
        assigned = chooseVariation(n, ranges);
      }

      // 9.5 Unenroll if any prior sticky buckets are blocked by version
      if (stickyBucketVersionIsBlocked) {
        process.env.NODE_ENV !== "production" && this.log("Skip because sticky bucket version is blocked", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId, undefined, true);
      }

      // 10. Return if not in experiment
      if (assigned < 0) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of coverage", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 11. Experiment has a forced variation
      if ("force" in experiment) {
        process.env.NODE_ENV !== "production" && this.log("Force variation", {
          id: key,
          variation: experiment.force
        });
        return this._getResult(experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId);
      }

      // 12. Exclude if in QA mode
      if (this._ctx.qaMode) {
        process.env.NODE_ENV !== "production" && this.log("Skip because QA mode", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 12.5. Exclude if experiment is stopped
      if (experiment.status === "stopped") {
        process.env.NODE_ENV !== "production" && this.log("Skip because stopped", {
          id: key
        });
        return this._getResult(experiment, -1, false, featureId);
      }

      // 13. Build the result object
      var result = this._getResult(experiment, assigned, true, featureId, n, foundStickyBucket);

      // 13.5. Persist sticky bucket
      if (this._ctx.stickyBucketService && !experiment.disableStickyBucketing) {
        var _this$_generateSticky = this._generateStickyBucketAssignmentDoc(hashAttribute, toString(hashValue), _defineProperty({}, this._getStickyBucketExperimentKey(experiment.key, experiment.bucketVersion), result.key)),
          changed = _this$_generateSticky.changed,
          attrKey = _this$_generateSticky.key,
          doc = _this$_generateSticky.doc;
        if (changed) {
          // update local docs
          this._ctx.stickyBucketAssignmentDocs = this._ctx.stickyBucketAssignmentDocs || {};
          this._ctx.stickyBucketAssignmentDocs[attrKey] = doc;
          // save doc
          this._ctx.stickyBucketService.saveAssignments(doc);
        }
      }

      // 14. Fire the tracking callback
      this._track(experiment, result);

      // 15. Return the result
      process.env.NODE_ENV !== "production" && this.log("In experiment", {
        id: key,
        variation: result.variationId
      });
      return result;
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._ctx.log) this._ctx.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "getDeferredTrackingCalls",
    value: function getDeferredTrackingCalls() {
      return this._deferredTrackingCalls;
    }
  }, {
    key: "setDeferredTrackingCalls",
    value: function setDeferredTrackingCalls(calls) {
      this._deferredTrackingCalls = calls;
    }
  }, {
    key: "fireDeferredTrackingCalls",
    value: function fireDeferredTrackingCalls() {
      var _this7 = this;
      var hasInvalidTrackingCall = false;
      this._deferredTrackingCalls.forEach(function (call) {
        if (!call || !call.experiment || !call.result) {
          console.error("Invalid deferred tracking call", {
            call: call
          });
          hasInvalidTrackingCall = true;
        } else {
          _this7._track(call.experiment, call.result);
        }
      });
      this._deferredTrackingCalls = [];
      if (hasInvalidTrackingCall) {
        throw new Error("Invalid tracking data");
      }
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._ctx.trackingCallback = callback;
      try {
        this.fireDeferredTrackingCalls();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "_track",
    value: function _track(experiment, result) {
      if (!this._ctx.trackingCallback) {
        this._deferredTrackingCalls.push({
          experiment: experiment,
          result: result
        });
        return;
      }
      var key = experiment.key;

      // Make sure a tracking callback is only fired once per unique experiment
      var k = result.hashAttribute + result.hashValue + key + result.variationId;
      if (this._trackedExperiments.has(k)) return;
      this._trackedExperiments.add(k);
      try {
        this._ctx.trackingCallback(experiment, result);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "_mergeOverrides",
    value: function _mergeOverrides(experiment) {
      var key = experiment.key;
      var o = this._ctx.overrides;
      if (o && o[key]) {
        experiment = Object.assign({}, experiment, o[key]);
        if (typeof experiment.url === "string") {
          experiment.url = getUrlRegExp(
          // eslint-disable-next-line
          experiment.url);
        }
      }
      return experiment;
    }
  }, {
    key: "_getHashAttribute",
    value: function _getHashAttribute(attr, fallback) {
      var hashAttribute = attr || "id";
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var hashValue = "";
      if (this._attributeOverrides[hashAttribute]) {
        hashValue = this._attributeOverrides[hashAttribute];
      } else if (this._ctx.attributes) {
        hashValue = this._ctx.attributes[hashAttribute] || "";
      } else if (this._ctx.user) {
        hashValue = this._ctx.user[hashAttribute] || "";
      }

      // if no match, try fallback
      if (!hashValue && fallback) {
        if (this._attributeOverrides[fallback]) {
          hashValue = this._attributeOverrides[fallback];
        } else if (this._ctx.attributes) {
          hashValue = this._ctx.attributes[fallback] || "";
        } else if (this._ctx.user) {
          hashValue = this._ctx.user[fallback] || "";
        }
        if (hashValue) {
          hashAttribute = fallback;
        }
      }
      return {
        hashAttribute: hashAttribute,
        hashValue: hashValue
      };
    }
  }, {
    key: "_getResult",
    value: function _getResult(experiment, variationIndex, hashUsed, featureId, bucket, stickyBucketUsed) {
      var inExperiment = true;
      // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
      if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
        variationIndex = 0;
        inExperiment = false;
      }
      var _this$_getHashAttribu3 = this._getHashAttribute(experiment.hashAttribute, this._ctx.stickyBucketService && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
        hashAttribute = _this$_getHashAttribu3.hashAttribute,
        hashValue = _this$_getHashAttribu3.hashValue;
      var meta = experiment.meta ? experiment.meta[variationIndex] : {};
      var res = {
        key: meta.key || "" + variationIndex,
        featureId: featureId,
        inExperiment: inExperiment,
        hashUsed: hashUsed,
        variationId: variationIndex,
        value: experiment.variations[variationIndex],
        hashAttribute: hashAttribute,
        hashValue: hashValue,
        stickyBucketUsed: !!stickyBucketUsed
      };
      if (meta.name) res.name = meta.name;
      if (bucket !== undefined) res.bucket = bucket;
      if (meta.passthrough) res.passthrough = meta.passthrough;
      return res;
    }
  }, {
    key: "_getContextUrl",
    value: function _getContextUrl() {
      return this._ctx.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "_urlIsValid",
    value: function _urlIsValid(urlRegex) {
      var url = this._getContextUrl();
      if (!url) return false;
      var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
      if (urlRegex.test(url)) return true;
      if (urlRegex.test(pathOnly)) return true;
      return false;
    }
  }, {
    key: "_hasGroupOverlap",
    value: function _hasGroupOverlap(expGroups) {
      var groups = this._ctx.groups || {};
      for (var i = 0; i < expGroups.length; i++) {
        if (groups[expGroups[i]]) return true;
      }
      return false;
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl() {
      return this._redirectedUrl;
    }
  }, {
    key: "_getNavigateFunction",
    value: function _getNavigateFunction() {
      if (this._ctx.navigate) {
        return this._ctx.navigate;
      } else if (isBrowser) {
        return function (url) {
          window.location.replace(url);
        };
      }
      return null;
    }
  }, {
    key: "_setAntiFlicker",
    value: function _setAntiFlicker() {
      if (!this._ctx.antiFlicker || !isBrowser) return;
      try {
        var _this$_ctx$antiFlicke;
        var styleTag = document.createElement("style");
        styleTag.innerHTML = ".gb-anti-flicker { opacity: 0 !important; pointer-events: none; }";
        document.head.appendChild(styleTag);
        document.documentElement.classList.add("gb-anti-flicker");

        // Fallback if GrowthBook fails to load in specified time or 3.5 seconds
        setTimeout(function () {
          document.documentElement.classList.remove("gb-anti-flicker");
        }, (_this$_ctx$antiFlicke = this._ctx.antiFlickerTimeout) !== null && _this$_ctx$antiFlicke !== void 0 ? _this$_ctx$antiFlicke : 3500);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "_applyDOMChanges",
    value: function _applyDOMChanges(changes) {
      if (!isBrowser) return;
      var undo = [];
      if (changes.css) {
        var s = document.createElement("style");
        s.innerHTML = changes.css;
        document.head.appendChild(s);
        undo.push(function () {
          return s.remove();
        });
      }
      if (changes.js) {
        var script = document.createElement("script");
        script.innerHTML = changes.js;
        document.head.appendChild(script);
        undo.push(function () {
          return script.remove();
        });
      }
      if (changes.domMutations) {
        changes.domMutations.forEach(function (mutation) {
          undo.push(mutate.declarative(mutation).revert);
        });
      }
      return function () {
        undo.forEach(function (fn) {
          return fn();
        });
      };
    }
  }, {
    key: "_deriveStickyBucketIdentifierAttributes",
    value: function _deriveStickyBucketIdentifierAttributes(data) {
      var attributes = new Set();
      var features = data && data.features ? data.features : this.getFeatures();
      var experiments = data && data.experiments ? data.experiments : this.getExperiments();
      Object.keys(features).forEach(function (id) {
        var feature = features[id];
        if (feature.rules) {
          var _iterator5 = _createForOfIteratorHelper(feature.rules),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var rule = _step5.value;
              if (rule.variations) {
                attributes.add(rule.hashAttribute || "id");
                if (rule.fallbackAttribute) {
                  attributes.add(rule.fallbackAttribute);
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      });
      experiments.map(function (experiment) {
        attributes.add(experiment.hashAttribute || "id");
        if (experiment.fallbackAttribute) {
          attributes.add(experiment.fallbackAttribute);
        }
      });
      return Array.from(attributes);
    }
  }, {
    key: "refreshStickyBuckets",
    value: function () {
      var _refreshStickyBuckets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(data) {
        var attributes;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!this._ctx.stickyBucketService) {
                _context13.next = 5;
                break;
              }
              attributes = this._getStickyBucketAttributes(data);
              _context13.next = 4;
              return this._ctx.stickyBucketService.getAllAssignments(attributes);
            case 4:
              this._ctx.stickyBucketAssignmentDocs = _context13.sent;
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function refreshStickyBuckets(_x20) {
        return _refreshStickyBuckets.apply(this, arguments);
      }
      return refreshStickyBuckets;
    }()
  }, {
    key: "_getStickyBucketAssignments",
    value: function _getStickyBucketAssignments() {
      var mergedAssignments = {};
      Object.values(this._ctx.stickyBucketAssignmentDocs || {}).forEach(function (doc) {
        if (doc.assignments) Object.assign(mergedAssignments, doc.assignments);
      });
      return mergedAssignments;
    }
  }, {
    key: "_getStickyBucketVariation",
    value: function _getStickyBucketVariation(experimentKey, experimentBucketVersion, minExperimentBucketVersion, meta) {
      experimentBucketVersion = experimentBucketVersion || 0;
      minExperimentBucketVersion = minExperimentBucketVersion || 0;
      meta = meta || [];
      var id = this._getStickyBucketExperimentKey(experimentKey, experimentBucketVersion);
      var assignments = this._getStickyBucketAssignments();

      // users with any blocked bucket version (0 to minExperimentBucketVersion) are excluded from the test
      if (minExperimentBucketVersion > 0) {
        for (var i = 0; i <= minExperimentBucketVersion; i++) {
          var blockedKey = this._getStickyBucketExperimentKey(experimentKey, i);
          if (assignments[blockedKey] !== undefined) {
            return {
              variation: -1,
              versionIsBlocked: true
            };
          }
        }
      }
      var variationKey = assignments[id];
      if (variationKey === undefined)
        // no assignment found
        return {
          variation: -1
        };
      var variation = meta.findIndex(function (m) {
        return m.key === variationKey;
      });
      if (variation < 0)
        // invalid assignment, treat as "no assignment found"
        return {
          variation: -1
        };
      return {
        variation: variation
      };
    }
  }, {
    key: "_getStickyBucketExperimentKey",
    value: function _getStickyBucketExperimentKey(experimentKey, experimentBucketVersion) {
      experimentBucketVersion = experimentBucketVersion || 0;
      return "".concat(experimentKey, "__").concat(experimentBucketVersion);
    }
  }, {
    key: "_getStickyBucketAttributes",
    value: function _getStickyBucketAttributes(data) {
      var _this8 = this;
      var attributes = {};
      this._ctx.stickyBucketIdentifierAttributes = !this._ctx.stickyBucketIdentifierAttributes ? this._deriveStickyBucketIdentifierAttributes(data) : this._ctx.stickyBucketIdentifierAttributes;
      this._ctx.stickyBucketIdentifierAttributes.forEach(function (attr) {
        var _this8$_getHashAttrib = _this8._getHashAttribute(attr),
          hashValue = _this8$_getHashAttrib.hashValue;
        attributes[attr] = toString(hashValue);
      });
      return attributes;
    }
  }, {
    key: "_generateStickyBucketAssignmentDoc",
    value: function _generateStickyBucketAssignmentDoc(attributeName, attributeValue, assignments) {
      var key = "".concat(attributeName, "||").concat(attributeValue);
      var existingAssignments = this._ctx.stickyBucketAssignmentDocs && this._ctx.stickyBucketAssignmentDocs[key] ? this._ctx.stickyBucketAssignmentDocs[key].assignments || {} : {};
      var newAssignments = _objectSpread({}, existingAssignments, assignments);
      var changed = JSON.stringify(existingAssignments) !== JSON.stringify(newAssignments);
      return {
        key: key,
        doc: {
          attributeName: attributeName,
          attributeValue: attributeValue,
          assignments: newAssignments
        },
        changed: changed
      };
    }
  }]);
  return GrowthBook;
}();